export default "__VITE_ASSET__27ea4265__"